export const appEnvironment = {
  CRISP: '',
  GOOGLE_ANALYTICS: {
    domain: 'auto',
    trackingId: 'UA-123775847-3'
  },
  HOTJAR: ''
};
